import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { URLS } from '../app-url.constant';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class OrganizationSetupService {
  constructor(private http: HttpClient) {}

  isEditing: boolean = false;
  routingPathBehaviourSubject = new BehaviorSubject('');

  getPercentage() {
    return this.http.get(
      `${URLS.baseApiHostUrl}${URLS.CorporateOfficeMaster.endpoint}${URLS.CorporateOfficeMaster.methods.CalculateProfileCompletionPercentage}`
    );
  }

  getListOfDepartment() {
    return this.http.get(
      `${URLS.baseApiHostUrl}${URLS.DepartmentMaster.endpoint}${URLS.DepartmentMaster.methods.GetAllDepartmentMasters}`
    );
  }

  addDepartment(requestBody: any) {
    return this.http.post(
      `${URLS.baseApiHostUrl}${URLS.DepartmentMaster.endpoint}${URLS.DepartmentMaster.methods.AddDepartmentMaster}`,
      requestBody
    );
  }

  GetAllIndustryTypeBySectorAndDivison(requestData: any) {
    let requestBody = this.generateRequestBody(requestData);
    return this.http.post(
      `${URLS.baseApiHostUrl}${URLS.Master.endpoint}${URLS.Master.methods.GetAllIndustryTypeBySectorAndDivison}`,
      requestBody
    );
  }

  GetAllIndustryDivisionBySector(requestData: any) {
    let requestBody = this.generateRequestBody(requestData);
    return this.http.post(
      `${URLS.baseApiHostUrl}${URLS.Master.endpoint}${URLS.Master.methods.GetAllIndustryDivisionBySector}`,
      requestBody
    );
  }

  getAllReportingFrequency() {
    return this.http.get(
      `${URLS.baseApiHostUrl}${URLS.Master.endpoint}${URLS.Master.methods.GetAllDataCapturingFrequency}`
    );
  }

  getReportingFrequencyById(id: any) {
    let param = {
      DataCapturingFrequencyId: id,
    };
    return this.http.get(
      `${URLS.baseApiHostUrl}${URLS.Master.endpoint}${URLS.Master.methods.GetReportingFrequencyMaster}`,
      { params: param }
    );
  }

  getAllUserType() {
    return this.http.get(
      `${URLS.baseApiHostUrl}${URLS.Master.endpoint}${URLS.Master.methods.GetAllUserTypeMaster}`
    );
  }

  GetAllDesignationMasters() {
    return this.http.get(
      `${URLS.baseApiHostUrl}${URLS.DesignationMaster.endpoint}${URLS.DesignationMaster.methods.GetAllDesignationMasters}`
    );
  }

  submitCorporateDetails(requestBody: any) {
    let param = {
      userLoginName: JSON.parse(localStorage.getItem('userData')!).username,
    };
    return this.http.post(
      `${URLS.baseApiHostUrl}${URLS.CorporateOfficeMaster.endpoint}${URLS.CorporateOfficeMaster.methods.AddCorporateOfficeMaster}`,
      requestBody,
      { params: param }
    );
  }

  updateCorporateDetails(requestBody: any) {
    return this.http.put(
      `${URLS.baseApiHostUrl}${URLS.CorporateOfficeMaster.endpoint}${URLS.CorporateOfficeMaster.methods.UpdateCorporateOfficeMaster}`,
      requestBody
    );
  }

  getCorporateDetails() {
    return this.http.get(
      `${URLS.baseApiHostUrl}${URLS.CorporateOfficeMaster.endpoint}${URLS.CorporateOfficeMaster.methods.GetCorporateOfficeMasterById}`
    );
  }

  getRegionalOfficeListById(id: any) {
    let param = {
      CorporateOfficeId: id ? id : 0,
    };
    return this.http.get(
      `${URLS.baseApiHostUrl}${URLS.RegionalOfficeMaster.endpoint}${URLS.RegionalOfficeMaster.methods.GetAllRegionalOfficeMaster}`,
      { params: param }
    );
  }

  submitRegionalDetails(requestBody: any) {
    let param = {
      userLoginName: JSON.parse(localStorage.getItem('userData')!).username,
    };
    return this.http.post(
      `${URLS.baseApiHostUrl}${URLS.RegionalOfficeMaster.endpoint}${URLS.RegionalOfficeMaster.methods.AddRegionalOfficeMaster}`,
      requestBody,
      { params: param }
    );
  }

  updateRegionalDetails(requestBody: any) {
    return this.http.put(
      `${URLS.baseApiHostUrl}${URLS.RegionalOfficeMaster.endpoint}${URLS.RegionalOfficeMaster.methods.UpdateRegionalOfficeMaster}`,
      requestBody
    );
  }

  deleteRegionalDetails(id: any) {
    let param = {
      Id: id,
    };
    return this.http.delete(
      `${URLS.baseApiHostUrl}${URLS.RegionalOfficeMaster.endpoint}${URLS.RegionalOfficeMaster.methods.DeleteRegionalOfficeMasterById}`,
      { params: param }
    );
  }

  DeleteOfficeContactPerson(id: any) {
    let param = {
      OfficeContactPersonID: id,
    };
    return this.http.delete(
      `${URLS.baseApiHostUrl}${URLS.CorporateOfficeMaster.endpoint}${URLS.CorporateOfficeMaster.methods.DeleteOfficeContactPerson}`,
      { params: param }
    );
  }

  getSiteOfficeDetails(id: any) {
    return this.http.get(
      `${URLS.baseApiHostUrl}${URLS.SiteOfficeMaster.endpoint}${URLS.SiteOfficeMaster.methods.GetAllSiteOfficeMaster}`
    );
  }

  submitSiteOfficeDetails(requestBody: any) {
    let param = {
      userLoginName: JSON.parse(localStorage.getItem('userData')!).username,
    };
    return this.http.post(
      `${URLS.baseApiHostUrl}${URLS.SiteOfficeMaster.endpoint}${URLS.SiteOfficeMaster.methods.AddSiteOfficeMaster}`,
      requestBody,
      { params: param }
    );
  }

  updateSiteOfficeDetails(requestBody: any) {
    return this.http.put(
      `${URLS.baseApiHostUrl}${URLS.SiteOfficeMaster.endpoint}${URLS.SiteOfficeMaster.methods.UpdateSiteOfficeMaster}`,
      requestBody
    );
  }

  deleteSiteOffice(id: any) {
    let param = {
      Id: id,
    };
    return this.http.delete(
      `${URLS.baseApiHostUrl}${URLS.SiteOfficeMaster.endpoint}${URLS.SiteOfficeMaster.methods.DeleteSiteOfficeMasterById}`,
      { params: param }
    );
  }

  getProjectList() {
    return this.http.get(
      `${URLS.baseApiHostUrl}${URLS.Master.endpoint}${URLS.Master.methods.GetAllProjectType}`
    );
  }

  isEmailIsUnique(requestBody: any) {
    return this.http.post(
      `${URLS.baseApiHostUrl}${URLS.ContactPerson.endpoint}${URLS.ContactPerson.methods.CheckContactPersonEmailExistence}`,
      requestBody
    );
  }

  isMobileIsUnique(requestBody: any) {
    return this.http.post(
      `${URLS.baseApiHostUrl}${URLS.ContactPerson.endpoint}${URLS.ContactPerson.methods.CheckContactPersonExistenceByContactNo}`,
      requestBody
    );
  }

  addDesignationMaster(requestBody: any) {
    return this.http.post(
      `${URLS.baseApiHostUrl}${URLS.DesignationMaster.endpoint}${URLS.DesignationMaster.methods.AddDesignationMaster}`,
      requestBody
    );
  }

  GetOrganizationDetailsById(requestData: any) {
    let requestBody = this.generateRequestBody(requestData);
    return this.http.post(
      `${URLS.baseApiHostUrl}${URLS.Master.endpoint}${URLS.Master.methods.GetOrganizationDetailsById}`,
      requestBody
    );
  }

  AddorUpdateOrganizationDetails(requestData: any) {
    let requestBody = this.generateRequestBody(requestData);
    return this.http.post(
      `${URLS.baseApiHostUrl}${URLS.Master.endpoint}${URLS.Master.methods.AddorUpdateOrganizationDetails}`,
      requestBody
    );
  }

  GetAllExchangeMaster() {
    return this.http.get(
      `${URLS.baseApiHostUrl}${URLS.Master.endpoint}${URLS.Master.methods.GetAllExchangeMaster}`
    );
  }

  GetAllCurrencyMaster() {
    return this.http.get(
      `${URLS.baseApiHostUrl}${URLS.Master.endpoint}${URLS.Master.methods.GetAllCurrencyMaster}`
    );
  }

  GetAllIndustryClassificationFormat() {
    return this.http.get(
      `${URLS.baseApiHostUrl}${URLS.Master.endpoint}${URLS.Master.methods.GetAllIndustryClassificationFormat}`
    );
  }

  generateRequestBody(data: any) {
    return {
      requestUserLoginName: JSON.parse(localStorage.getItem('userData')!)
        .username,
      requestId: 'string',
      data: data,
      message: 'string',
    };
  }

  getEmissionStandardFactorsListAsync() {
    return this.http.get(
      `${URLS.baseApiHostUrl}${URLS.Master.endpoint}${URLS.Master.methods.getEmissionStandardFactorsListAsync}`
    );
  }
}
